/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DraggableList/view.blocks to change it.
import Children from 'Simple/Children'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function DraggableList({
  children,
  viewPath = "/DesignSystem/DraggableList"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="DraggableList.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<Children
  viewPath={`${viewPath}/Children`}
>
{children}
</Children>
</div>
</React.Fragment>)
}